import { FC } from "react";
import Card from "react-bootstrap/Card";
import { FaInfoCircle } from "react-icons/fa";

export const AllCompanyRolePermissionsOverviewCard: FC = () => (
    <Card>
        <Card.Body>
            <Card.Title className="mb-3">
                <FaInfoCircle /> Roles
            </Card.Title>
            <Card.Subtitle>Standard</Card.Subtitle>
            <ul>
                <li>
                    Can only view reports in this company that they have been added to - the report role will apply
                    privileges at the report-level
                </li>
            </ul>
            <Card.Subtitle>Owner</Card.Subtitle>
            <ul>
                <li>Can view all reports in the company, even if not directly added to them</li>
                <li>Can invite other users to the company, including new owners</li>
                <li>Can list and delete company invites</li>
                <li>Can remove users from the company</li>
            </ul>
        </Card.Body>
    </Card>
);
